import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Tabs, Tab, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  tabsRoot: {
    minHeight: 'auto',
    width: '100%',
    '& .MuiTabs-flexContainer': {
      overflow: 'auto',
      msOverflowStyle: 'none',  // Hide scrollbar in IE and Edge
      scrollbarWidth: 'none',   // Hide scrollbar in Firefox
      cursor: 'grab',
      padding: '0 8px', // Reduced padding
      '&:active': {
        cursor: 'grabbing'
      },
      '&::-webkit-scrollbar': {
        display: 'none'         // Hide scrollbar in Chrome, Safari and Opera
      },
    },
    '& .MuiTabs-scroller': {
      overflow: 'visible !important',
      padding: '0 8px', // Reduced padding
    },
    '& .MuiTab-root': {
      minWidth: 'auto', // Allow tabs to be as narrow as their content
      padding: '12px 8px', // Reduced padding
      whiteSpace: 'nowrap', // Prevent text wrapping
    },
  },
}));

const CustomTabs = ({ tabs, onChange, tabClassName }) => {
  const classes = useStyles();
  const history = useHistory();
  const [currentTab, setCurrentTab] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleStart = (e) => {
    setIsDragging(true);
    const clientX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
    setStartX(clientX - e.currentTarget.offsetLeft);
    setScrollLeft(e.currentTarget.scrollLeft);
  };

  const handleMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const clientX = e.type.includes('mouse') ? e.pageX : e.touches[0].pageX;
    const x = clientX - e.currentTarget.offsetLeft;
    const walk = (x - startX) * 2;
    e.currentTarget.scrollLeft = scrollLeft - walk;
  };

  const handleEnd = () => {
    setIsDragging(false);
  };

  const { adminContactPreview, adminContactPreviewPrevState } = useSelector(state => state.campaign);

  useEffect(() => {
    if (adminContactPreview !== adminContactPreviewPrevState) {
      history.push(history.location.pathname);
    }
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(history.location.search);

    if (queryParams.get('currentTab')) {
      const currentTabValue = parseInt(queryParams.get('currentTab'));
      setCurrentTab(currentTabValue);
      onChange(currentTabValue);
      return;
    }

    setCurrentTab(0);
    onChange(0);
  }, [history.location.search]);

  const handleChange = (event, value) => {
    const pathname = value === 0 ?
      history.location.pathname :
      `${history.location.pathname}?currentTab=${value}`;
    history.push(pathname);

    setCurrentTab(value);
    onChange(value);
  };

  const getTab = (tab) => {
    if (tab.icon && tabClassName) {
      return (
        <Tab
          key={tab.value}
          className={tabClassName}
          label={tab.label}
          value={tab.value}
          icon={tab.icon} />
      );
    }

    if (tab.icon) {
      return (
        <Tab
          key={tab.value}
          label={tab.label}
          value={tab.value}
          icon={tab.icon} />
      );
    }

    if (tabClassName) {
      return (
        <Tab
          key={tab.value}
          className={tabClassName}
          label={tab.label}
          value={tab.value} />
      );
    }

    return (
      <Tab
        key={tab.value}
        label={tab.label}
        value={tab.value} />
    );
  };

  return (
    <Tabs
      variant="scrollable"
      scrollButtons="auto"
      textColor="primary"
      value={currentTab}
      onChange={handleChange}
      className={classes.tabsRoot}
      onMouseDown={handleStart}
      onMouseMove={handleMove}
      onMouseUp={handleEnd}
      onMouseLeave={handleEnd}
      onTouchStart={handleStart}
      onTouchMove={handleMove}
      onTouchEnd={handleEnd}
    >
      {tabs.map(getTab)}
    </Tabs>
  );
};

export default CustomTabs;
